// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feedItemHeader":"_1cMhOMFaKzHKexfjZk6JQK","whitePaperResearchItem":"_3E04GfQRcmQwU-fX5GdlYV"};